import { object, string } from 'yup'

export const validationSchema = object({
  workOrderInput: string()
    .matches(/^[0-9]+$/, 'Solo se permiten números')
    .required('El campo código de almacén es requerido.')
    .min(0)
})

export const checkDispatchFormInitialValues = {
  workOrderInput: ''
}
